import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import { CombinedContext } from '@ustra/nuxt/src/vue/store'
import { Mobile } from '@ustra/nuxt/src/vue/plugins/func/mobile'
import * as storageKey from './storage-key'

export interface User {
  userId?: string
  userNm?: string
  userGbcd?: string
  venCd?: string
  venNm?: string
  ven2Cd?: string
  ven2Nm?: string
  ak?: string
  esUserGB?: string
  esUserName?: string
  esUserCd?: string
  cshwCd?: string
}

export interface HsAuthState {
  mobile: Mobile
  currentUser: User
  loginToken: string
}

@Module({
  name: 'hsAuth',
  namespaced: true,
  stateFactory: true,
})
export class HsAuthModule extends VuexModule implements HsAuthState {
  /**
   * 모바일
   */
  mobile: Mobile = null

  /**
   * 현재 사용자 정보
   */
  currentUser: User = null

  /**
   * 로그인 토큰 정보
   */
  loginToken: string = null

  @Mutation
  setMobile(mobile: Mobile) {
    this.mobile = mobile
  }

  @Mutation
  setCurrentUser(user: User) {
    this.currentUser = user
  }

  @Action
  mapUser(tokenClaim: any) {
    return {
      userId: tokenClaim.userId,
      userNm: tokenClaim.userNm,
      userGbcd: tokenClaim.userGbcd,
      venCd: tokenClaim.venCd,
      venNm: tokenClaim.venNm,
      ven2Cd: tokenClaim.ven2Cd,
      ven2Nm: tokenClaim.ven2Nm,
      ak: tokenClaim.ak,
    }
  }

  @Action
  async loadUserInfo() {
    const tokenClaim = this.context.rootGetters['auth/tokenClaim']

    if (tokenClaim) {
      await this.setCurrentUser(await this.mapUser(tokenClaim))
    } else {
      await this.setCurrentUser({})
    }
  }

  @Mutation
  async setLoginToken(loginToken: string) {
    this.loginToken = loginToken

    if (this.mobile.isNativeRequest) await this.mobile.bridge.staticFunctions.storage().setItem(storageKey.LOGIN_TOKEN, loginToken)
    else localStorage.setItem(storageKey.LOGIN_TOKEN, loginToken)
  }

  @Mutation
  async setExtUser(item: string) {
    if (this.mobile.isNativeRequest) await this.mobile.bridge.staticFunctions.storage().setItem(storageKey.EXT_TOKEN, item)
    else localStorage.setItem(storageKey.EXT_TOKEN, item)
  }

  @Action
  async getExtUser() {
    const extUserInfo = this.mobile.isNativeRequest ? await this.mobile.bridge.staticFunctions.storage().getItem(storageKey.EXT_TOKEN) : localStorage.getItem(storageKey.EXT_TOKEN)
    if (extUserInfo != null && extUserInfo !== 'null') {
      return JSON.parse(extUserInfo)
    }
    return { cshwCd: '', esUserGB: '', esUserCd: '', esUserName: '' }
  }

  @Action
  nuxtServerInit(_arg: CombinedContext) {}

  @Action
  async nuxtClientInit(_arg: CombinedContext) {
    this.setMobile(_arg.context.$ustra.mobile)
    this.loadUserInfo()

    // 로그인 토큰
    const loginToken = this.mobile.isNativeRequest ? await this.mobile.bridge.staticFunctions.storage().getItem(storageKey.LOGIN_TOKEN) : localStorage.getItem(storageKey.LOGIN_TOKEN)
    this.setLoginToken(loginToken)
  }
}
